<template>
  <div id="baikecontent">
    <div class="bk-bg">
      <div class="container">
        <div style="padding-top: 40px;"></div>
        <div class="float-left">
					<span class="float-left">
						<h2 style="font-size: 30px;">{{list.name}}</h2>
					</span>
          <span class="float-left change-sc el-icon-star-on" @click="addcollect(list.id)">
						<font style="font-size: 16px;margin-left: 10px;">{{collect}}</font>
					</span>
          <div class="clearfix"></div>
          <div class="yr-intro">{{list.detailed}}</div>

          <div style="width: 400px;float: left;">`
            <div id="myChart" class="dailyChart " style="width:400px;height: 300px;"></div>
            <center>《艺人之家》搜索指数</center>
          </div>
          <div class="zsfm float-left">
            <img :src="filmpic" width="150" height="auto">
            <img :src="tvpic" width="150" height="auto">
            <center>演员作品展示</center>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="float-right">
          <img :src="list.picture" width="300" height="400" :alt="list.name"/>
          <div style="width: 300px;margin-top: 20px;">
            <img class="float-left" src="http://img.yopoo.cn/rz_icon.png" width="80" height="auto">
            <div style="width: 200px;" class="float-right">经过「艺人之家」官方权威认证，确保演员信息的真实性——艺人之家只做真实的演员数据！</div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="container ">
      <div class=" padding50">
        <div class="index-con-wd bk">
          <h2>基本信息</h2>
          <h4>BASIC INFORMATION</h4>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="float-left bk-base">

        <span class="bk-base-span">中文名：{{list.name}}</span>
        <span class="bk-base-span">英文名：{{list.english_name}}</span>
        <span class="bk-base-span">民族：{{list.nation}}</span>
        <span class="bk-base-span" v-if="this.list.constellation">星座：{{list.constellation}}</span>
        <span class="bk-base-span" v-if="this.list.blood">血型：{{list.blood}}型</span>
        <span class="bk-base-span">身高：{{list.stature}}Cm</span>
        <span class="bk-base-span">体重：{{list.weight}}Kg</span>
        <span class="bk-base-span" v-if="this.list.place">出生地：{{list.place}}</span>
        <span class="bk-base-span">出生日期：{{list.bom_time}}</span>
        <span class="bk-base-span">职业：{{list.vocation}}</span>
        <span class="bk-base-span" style="width: 460px;" v-if="this.list.school">毕业院校：{{list.school}}</span>
        <p style="line-height: 44px; border-bottom: 1px dashed #a3a3a3;">特长：
          <span class="" v-for="item in list.perf_keyword" v-if="item.state===1" :key="item.id">
						{{item.tag}} |
					</span>
        </p>
        <p style="line-height: 44px; border-bottom: 1px dashed #a3a3a3;">标签：
          <span class="" v-for="item in list.perf_keyword" v-if="item.state===2" :key="item.id">
						{{item.tag}} |
					</span>
        </p>
        <div class="clearfix"></div>
      </div>
      <div class="float-right">
        <video width="600" height="350" :src="list.video" controls v-if="list.video==='' ? false:true">
          您的浏览器不支持 video 标签。
        </video>
        <img width="600" height="350" src="http://img.yopoo.cn/spds_img.png" v-if="list.video==='' ? true:false">
      </div>
      <div class="clearfix"></div>
    </div>

    <!-- 时间轴 -->
    <div class="container">
      <div class="padding50">
        <div class="index-con-wd bk">
          <h2>电影作品</h2>
          <h4>MOVIE WORK</h4>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class=" margintop20" v-if="list.film_works==='' ? true:false">暂无数据</div>
      <div class=" margintop20" v-if="list.film_works==='' ? false:true">
        <div class="coverpic"><img align="right" :src="filmpic" width="250" height="auto" @click="pics(1)"></div>
        <div v-html="list.film_works"></div>

        <!-- <div class="clearfix"></div> -->
      </div>
      <div class="clearfix"></div>

    </div>
    <div class="container">
      <div class="padding50">
        <div class="index-con-wd bk">
          <h2>电视剧作品</h2>
          <h4>TV WORK</h4>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class=" margintop20" v-if="list.tv_works==='' ? true:false">暂无数据</div>
      <div class=" margintop20" v-if="list.tv_works==='' ? false:true">

        <div class="coverpic"><img align="right" :src="tvpic" width="250" height="auto" @click="pics(2)"></div>
        <div v-html="list.tv_works"></div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="container">
      <div class="padding50">
        <div class="index-con-wd bk">
          <h2>广告作品</h2>
          <h4>ADVERTISING WORK</h4>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class=" margintop20" v-if="list.advertising_works==='' ? true:false">暂无数据</div>
      <div class="margintop20" v-if="list.advertising_works==='' ? false:true">

        <div class="coverpic"><img align="right" :src="advpic" width="250" height="auto" @click="pics(3)"></div>
        <div v-html="list.advertising_works"></div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class=""
    <div class="container">
      <div class="padding50">
        <div class="index-con-wd bk">
          <h2>演员展示</h2>
          <h4>ACTOR SHOW</h4>
        </div>
        <div class="clearfix"></div>
      </div>

      <!-- swiper -->
      <swiper :options="swiperOption">
        <swiper-slide v-for="item in list.perf_picture" :key="item.id">
          <img :src="item.image_url" width="220" height="auto" :alt="list.name" @click="pics(4)">
        </swiper-slide>
      </swiper>

      <div class="padding50">
        <div class="index-con-wd bk">
          <h2>新闻报道</h2>
          <h4>NEWS REPORT</h4>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="index-con-tit">
        <ul>
          <!-- <li class="float-left list-shadow" v-for="item in list.essay" :key="item.id">
                        <router-link :to="'/hotcontent/'+item.id">
                            <img class="float-left" :src="item.picture" width="100%" height="auto">
                            <div class="float-left bk-con-sty">
                                <h3 style="margin-left:10px;padding-top: 10px;">{{item.title}}</h3>
                                <p style="font-size:14px;padding-top:10px;margin-left: 10px;">{{item.intro}}</p>
                            </div>
                            <div class="clearfix"></div>
                        </router-link>
                    </li> -->
          <li class="hotlist-sty" v-for="item in list.essay" :key="item.id">
            <router-link :to="'/hotcontent/'+item.id">
              <img class="float-left" width="100%" height="auto" v-bind:src="item.picture" v-bind:alt="item.name"/>
              <div style=" height: 220px;float: left;position: relative">
                <div class="hotlist-sty-wd">
                  <h2>{{item.title}}</h2>
                  <!-- <p class="hotlist-time">{{item.create_time}}</p> -->
                  <p v-html="item.intro"></p>
                  <div class="clearfix"></div>
                </div>
                <a href="" class="hotlist-more">MORE</a>
              </div>
            </router-link>
            <div class="clearfix"></div>
          </li>
          <div class="clearfix"></div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import Axios from 'axios'
  import storage from '../storage/storage.js'

  export default {
    data() {
      return {
        list: {},
        tvpic: [],
        advpic: [],
        getdata: '',
        filmpic: [],
        collect: '加入收藏',
        swiperOption: {
          // autoplay: 2000,
          speed: 2000,
          loop: false,
          slidesPerView: 5,
          autoplayDisableOnInteraction: false,
        },
      }
    },
    components: {
      swiper,
      swiperSlide,
    },
    methods: {
      pics(num) {
// 				this.bus.$emit('aid',this.$route.params.id)
// 				this.bus.$emit('cid',num)
        storage.set('aid', this.$route.params.id)
        storage.set('cid', num)
        let routeUrl = this.$router.resolve("/pics")
        window.open(routeUrl.href, '_blank');
      },
      requestData(id) { //渲染页面详细信息
        var api = 'https://api.yopoo.cn/api/v1/actor?id=' + id;

        this.$http.get(api).then((response) => {
          this.list = response.body;
          var pics = this.list.perf_works_picture
          for (var i = 0; i < pics.length; i++) {
            if (pics[i].number === 1) {
              this.filmpic = pics[i].image_url
            }
            if (pics[i].number === 2) {
              this.tvpic = pics[i].image_url
            }
            if (pics[i].number === 3) {
              this.advpic = pics[i].image_url
            }
          }
          if (response.body.code == 202) { //判断不存在的id，然后跳转上一层级
            this.$message({
              message: response.body.msg,
              type: 'error',
              center: true

            });
            setTimeout(() => {
              this.$router.push('/baike')
            }, 1000)
          }
        }, (err) => {
          console.log(err)
        })

      },
      addcollect(id) { //添加收藏
        var api = 'https://api.yopoo.cn/api/centre/collect?state=1&id=' + id
        var token = storage.get('token')
        if (token == null) {
          this.$message({
            message: '请先登录！',
            type: 'warning',
            center: true

          });
          $(function () {
            $('.el-icon-star-on').css('color', 'grey')
          })
        } else {
          Axios.get(api).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.msg,
                type: 'success',
                center: true
              });
              this.collect = '已收藏'
              $(function () {
                $('.el-icon-star-on').css('color', 'red')
              })
            }
            if (res.data.code == 202) {
              this.$message({
                message: res.data.msg,
                type: 'warning',
                center: true
              });
            }

          })
        }

      },
      testcollect(id) { //判断是否收藏
        var api = 'https://api.yopoo.cn/api/centre/selecollect?state=1&id=' + id //判断是否收藏接口

        this.$http.get(api).then((res) => {
          if (res.data == 1) { //判断res.data的值，为1的时候是已收藏，然后修改样式
            this.collect = '已收藏'
            $(function () {
              $('.el-icon-star-on').css('color', 'red')
            })
          }

        })

      },
      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        // 绘制图表
        myChart.setOption({
          title: {
            text: ''
          },
          tooltip: {},
          xAxis: {
            data: []
          },
          yAxis: {},
          series: [{
            name: '指数',
            type: 'line',
            data: [
              Math.floor(Math.random() * (35 - 10 + 1) + 2),
              Math.floor(Math.random() * (35 - 10 + 1) + 2),
              Math.floor(Math.random() * (30 - 15 + 1) + 2),
              Math.floor(Math.random() * (30 - 20 + 1) + 2),
              Math.floor(Math.random() * (35 - 25 + 1) + 2),
              Math.floor(Math.random() * (35 - 20 + 1) + 2),
              Math.floor(Math.random() * (35 - 10 + 1) + 2),
              Math.floor(Math.random() * (35 - 20 + 1) + 2),
              Math.floor(Math.random() * (30 - 15 + 1) + 2),
              Math.floor(Math.random() * (35 - 20 + 1) + 2),
              Math.floor(Math.random() * (35 - 25 + 1) + 2),
              Math.floor(Math.random() * (25 - 20 + 1) + 2)
            ]
          }]
        });
      }

    },
    mounted() {
      var id = this.$route.params.id;
      this.requestData(id); //默认渲染页面详情
      this.testcollect(id)
      this.drawLine(); //echarts
      var newdata = new Date();
      this.getdata = newdata.toLocaleString()
    },
    metaInfo() {
      return {
        title: this.list.name?`${this.list.name}艺人百科—打造影视行业优秀的资源聚合服务平台`:'',
        meta: [{
          name: 'keywords',
          content: ''
        },
          {
            name: 'description',
            content: ''
          }
        ]
      }
    },
  }
</script>
<style scoped>
  /* body {
        background: #fff;
    }
 */

  .bk-bg {
    background-image: url("http://yopoo.oss-cn-beijing.aliyuncs.com/bg-bk.jpg");
    background-size: 100% auto;
    background-repeat: repeat;
    padding: 30px 0;

  }
</style>



// WEBPACK FOOTER //
// src/components/BaikeContent.vue